import { createApp } from 'vue'
import App from './App.vue'
import router from './router'  // 导入路由配置
import store from './store'; // Import Vuex store

import './css/global.css';  // Import the global CSS file
// import './css/rwd.css';  // Import the responsive web design CSS file
import './css/text.css';  // Import the text CSS file
import './css/button.css';  // Import the button CSS file
import './css/card.css';  // Import the card CSS file
import './css/detail.css';  // Import the detail CSS file

// store.dispatch('user/login', { username: 'admin', password: '12345' }); // Example login call
// store.dispatch('parking/fetchParkingList'); // Fetch parking list
// store.dispatch('offers/fetchOfferCards'); // Fetch offer cards
import VueLinkify from 'vue-linkify';


import ModalContainer from './components/ModalContainer.vue';
// import OfferCardModal  from '@/views/login/OfferCardModal.vue';
import PullDAO from './services/PullDAO.js';
import { globalParams } from './global.js';

const app = createApp(App)

app.directive('linkified', VueLinkify);


store.dispatch('initWebSocket'); // Initialize WebSocket connection
store.dispatch('fetchOfferCards'); // Fetch offer cards
// store.dispatch('getParkingList'); // Fetch parking list
// store.dispatch('getOfferList',{row=10; page=1}); // Fetch offer list

app.use(store); // Use Vuex store

app.use(router)  // 使用路由



// Create a separate instance for ModalContainer
const modalContainer = createApp(ModalContainer);
const modalInstance = modalContainer.mount(document.createElement('div'));
document.body.appendChild(modalInstance.$el);

// Expose modal methods globally
app.config.globalProperties.$modal = {
    showModal(config) {
        modalInstance.showModal(config);
    },
    closeModal() {
        modalInstance.closeModal();
    }
};


(async () => {
    // Fetch all parkings before app mounts
    const pullDAO = new PullDAO();
    try {
        const allParkings = await pullDAO.fetchAllParkings();
        globalParams.parkings = allParkings;
        console.log('Global parkings loaded:', globalParams.parkings);
    } catch (error) {
        console.error('Failed to fetch global parkings:', error);
    }
    
    app.use(store);
    app.use(router);
    // Final mount after fetching parkings & loading maps


     // ✅ ⭐ 加在這裡（關鍵位置）
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ParkingFacility",
      "name": "台灣聯通停車場",
      "url": "https://www.taiwan-parking.com.tw/",
      "areaServed": "Taiwan",
      "description": "提供停車場查詢、月租與線上繳費服務",
      "availableLanguage": "zh-TW",
      "serviceType": ["停車場查詢","月租停車","線上繳費"]
    });
    document.head.appendChild(script);
    
    app.mount('#app');
})();
